import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export type UpdateSingleBillPageStore = UseBoundStore<StoreApi<IUpdateSingleBillSlice>>;

export interface IUpdateSingleBillSlice {
  isUpdateSingleBillLoading: boolean;
  isUpdateSingleBillSuccess: boolean;
  updateSingleBillError: Error | null;
  updateSingleBillIsFormChanged: boolean;
  updateSingleBillPaymentCanBeUpdated: boolean;
}

export const createUpdateSingleBillSliceDefaultValues = (): IUpdateSingleBillSlice => ({
  isUpdateSingleBillSuccess: false,
  isUpdateSingleBillLoading: false,
  updateSingleBillError: null,
  updateSingleBillIsFormChanged: false,
  updateSingleBillPaymentCanBeUpdated: false,
});

export const createUpdateSingleBillSlice: StateCreator<IUpdateSingleBillSlice> = () =>
  createUpdateSingleBillSliceDefaultValues();

export const createUpdateSingleBillHooks = (pageStore: UpdateSingleBillPageStore) => ({
  useIsLoading: () => pageStore((state) => state.isUpdateSingleBillLoading),
  useFormIsDirty: () => pageStore((state) => state.updateSingleBillIsFormChanged),
  usePaymentCanChange: () => pageStore((state) => state.updateSingleBillPaymentCanBeUpdated),
});

export type UpdateSingleBillHooks = ReturnType<typeof createUpdateSingleBillHooks>;
